import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { BookingsOptionsBase } from './BookingsOptions'

import { modalActions } from 'reduxModules/actions/ModalActions'
import { isPartnerSelector, isLimitedDispatcherSelector } from 'reduxModules/selectors/UserSelectors'
import {
  bookingsWithoutBlacklistSelector,
  ticketBookingsSelector,
  returnBookingsSelector } from 'reduxModules/selectors/BookingSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  bookings: bookingsWithoutBlacklistSelector,
  isPartner: isPartnerSelector,
  isLimitedDispatcher: isLimitedDispatcherSelector,
  ticketBookings: ticketBookingsSelector,
  returnBookings: returnBookingsSelector,
})

const mapDispatchToProps = {
  showModal: modalActions.showModal
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const BookingsOptions = enhance(BookingsOptionsBase)



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsOptions/index.js